module.exports = __webpack_public_path__ + "img/ira.2c746657.png";